import React, { useState, useContext } from "react";
import {
  Row,
  Col,
  PageHeader,
  Button,
  Modal,
  Form,
  Input,
  Typography,
  Avatar,
  Spin
} from "antd";
import { showMessage } from '../../../utils/MessageDataSign'

import "../../../styles/HeaderDetails.css";
import { v4 as uuidv4 } from 'uuid'
import { API, graphqlOperation } from "aws-amplify";
import { useNavigate } from "react-router-dom";
import { UserContext } from '../../../GestorContext'
import * as mutations from "../../../graphql/mutations";
import { TopValue, TotalAudience, TopValueBE, TotalAudienceBE, TotalFilter, TotalTwoFilters } from "./MaxValues";
import { useEffect } from "react";
const { Title, Text } = Typography;


const HeaderDetails = ({ data, filters, isQueryRunning, setButtonClicked, dataBaseExternal, setFilters, setGenero, setUbicaciones, setRangeNavigationDate, setRangeNavigationHour, setDateNavigationRange, setComportamientos, setHourNavigationRange, setPlanCost, setEdad, setDataConsumed, setAdditionalTelco, setAdditionalNoTelco, setMarca, setTipo, setTipoSuscripcion, setMercado, setLineAge, setUserPlan, setServicio, setAplicacion ,setGama, setVersionSO, setTecnologia, setTecNavegacion, setSistemaOperativo, dataAudience, dateNavigationRange, totalAudience, totalNewAudience, params, totalBE, loadingTotal, topPlanCost, topEdad, topMarca, topMercado, topServicio, topAplicacion, topTipoSuspcricion, topGama, topDispositivos, topGeneros, topUbicaciones, topComportamientos, setFiltersActived, setSwitchUbicaciones, setSwitchGeneros, setSwitchEdades, setSwitchDataConsumed, setSwitchAdditionalTelco, setSwitchAdditionalNoTelco, setSwitchMarcas, setSwitchTipos, setSwitchTipoSuscripcion, setSwitchMercado, setSwitchLineAge, setSwitchUserPlan, setSwitchServicio, setSwitchAplicacion, setSwitchGama, setSwitchVersionSO, setSwitchTecnologia, setSwitchTecNavegacion, setSwitchSO, setSwitchComportamientos, setDataMap, setDataDias, setDataHoras, setDataGenero, setDataEdad, setDataDataConsumed, setDataAdditionalTelco, setDataAdditionalNoTelco, setDataMarca, setDataTipo, setDataTipoSuscripcion, setDataGama, setDataVersionSO, setDataTecnologia, setDataTecNavegacion, setDataMercado, setDataLineAge, setDataUserPlan, setDataServicio, setDataAplicacion, setDataSistema,  setDataComportamientos, setSwitchPlanCost, setDataPlanCost}) => {
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpen2, setIsModalOpen2] = useState(false);
  const [isModalOpen3, setIsModalOpen3] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [totalAudienceValue, setTotalAudienceValue] = useState()
  const [totalNewAudienceValue, setTotalNewAudienceValue] = useState()
  const [totalBDexternaAudience, settotalBDexternaAudience] = useState(0)

  const userContext = useContext(UserContext)

  const navigate = useNavigate();

  const showModal = () => {
    setIsModalOpen(true);
  };

  const showModal2 = () => {
    setIsModalOpen2(true);
  };

  const showModal3 = () => {
    setIsModalOpen3(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setIsModalOpen2(false);
    setIsModalOpen3(false);
  };

  useEffect(() => {
    setButtonClicked(prevState => !prevState)
  }, [dataAudience.name])

  async function onFinish() {
    try {
      const auxTotal = totalBDexternaAudience !== null ? totalBDexternaAudience : totalNewAudienceValue;
      const values = await form.validateFields();
      let mutationVariables = {
        input: {
          name: values.name,
          filters: filters,
          isPublic: true,
          audienceUserId: userContext.attributes.sub,
          count: auxTotal,
          groups: userContext.attributes['custom:group'],
          audienceClmId: dataBaseExternal
        },
      };
      if (dataBaseExternal !== null) {
        mutationVariables.input.audienceClmId = dataBaseExternal;
      }
  
      const result = await API.graphql(
        graphqlOperation(`
          mutation createAudienceCustom(
            $input: createAudienceCustomInput!
          ) {
            createAudienceCustom(input: $input) {
              id
              name
            }
          }`
          , mutationVariables)
      );
      setIsModalOpen(false);
      navigate(`/audiences`);
      return { id: result.data.createAudienceCustom.id, name: result.data.createAudienceCustom.name };    
    } catch (err) {
      showMessage('error', 'Error al crear la audiencia', 3);
    }
  }

  async function CreateAudience(){
    const audiencia = await onFinish(); 
    await createLog({
      action: `Creación de audiencia"`,
      id: uuidv4(),
      user:userContext.username,
      view:"Principal",
    });
  }

  async function handleOk() {
    try {
      const auxTotal = totalBDexternaAudience !== null ? totalBDexternaAudience : totalNewAudienceValue;
      const result = await API.graphql(
        graphqlOperation(`
        mutation updateAudienceCustom(
          $input: updateAudienceCustomInput!
        ) {
          updateAudienceCustom(input: $input) {
            id
          }
      }` , {
          input: {
            id: params.id,
            name: dataAudience.name,
            filters: filters,
            audienceUserId: dataAudience.audienceUserId,
            count: auxTotal,
            audienceClmId: dataBaseExternal,
          },
        })
      );
      setIsModalOpen2(false);
      navigate(`/audiences`);
    } catch (err) {
      showMessage('error', 'Error al editar la audiencia', 3);
    }
  }

  async function UpdateAudience(){
    await handleOk();
    
    await createLog({
      action: `La audiencia con el ID: "${dataAudience.id}" y nombre: "${dataAudience.name}" fue editada`,
      id: uuidv4(),
      user:userContext.username,
      view:"Principal",
    });
  }

  

  const createLog = async (values) => {
    const usuario = await API.graphql({
     query: `mutation CreateMetrics( $input: CreateMetricsInput!){
                createMetrics(input:$input) {
                    id
                }
            }`,
        variables: {
            input : values
          },
        });
  };


  async function onFinishFilter() {
    try {
      setUbicaciones([]);
      setGenero([]);
      setFilters([]);
      setPlanCost([]);
      setEdad([]);
      setMarca([]);
      setDataConsumed([]);
      setAdditionalTelco([]);
      setAdditionalNoTelco([]);
      setTipo([]);
      setTipoSuscripcion([]);
      setMercado([]);
      setLineAge([]);
      setUserPlan([]);
      setServicio([]);
      setAplicacion([]);
      setGama([]);
      setVersionSO([]);
      setTecnologia([]);
      setTecNavegacion([]);
      setComportamientos([]);
      setSistemaOperativo([]);
      setRangeNavigationDate();
      setDateNavigationRange(["", ""]); 
      setRangeNavigationHour();
      setHourNavigationRange(["", ""]); 
      setIsModalOpen3(false);
      setSwitchUbicaciones(false);
      setSwitchGeneros(false);
      setSwitchEdades(false);
      setSwitchPlanCost(false);
      setSwitchMarcas(false);
      setSwitchDataConsumed(false);
      setSwitchAdditionalTelco(false);
      setSwitchAdditionalNoTelco(false);
      setSwitchTipos(false);
      setSwitchTipoSuscripcion(false);
      setSwitchMercado(false);
      setSwitchLineAge(false);
      setSwitchUserPlan(false);
      setSwitchServicio(false);
      setSwitchAplicacion(false);
      setSwitchGama(false);
      setSwitchVersionSO(false);
      setSwitchTecnologia(false);
      setSwitchTecNavegacion(false);
      setSwitchSO(false);
      setSwitchComportamientos(false);
      setFiltersActived(true);
      setDataMap({ total: null, newAudience: null, dataExternalBD: null })
      setDataDias({ total: null, newAudience: null, dataExternalBD: null })
      setDataHoras({ total: null, newAudience: null, dataExternalBD: null })
      setDataGenero({ total: null, newAudience: null, dataExternalBD: null })
      setDataPlanCost({ total: null, newAudience: null, dataExternalBD: null })
      setDataEdad({ total: null, newAudience: null, dataExternalBD: null })
      setDataMarca({ total: null, newAudience: null, dataExternalBD: null })
      setDataDataConsumed({ total: null, newAudience: null, dataExternalBD: null })
      setDataAdditionalTelco({ total: null, newAudience: null, dataExternalBD: null })
      setDataAdditionalNoTelco({ total: null, newAudience: null, dataExternalBD: null })
      setDataTipo({ total: null, newAudience: null, dataExternalBD: null })
      setDataTipoSuscripcion({ total: null, newAudience: null, dataExternalBD: null })
      setDataMercado({ total: null, newAudience: null, dataExternalBD: null })
      setDataLineAge({ total: null, newAudience: null, dataExternalBD: null })
      setDataUserPlan({ total: null, newAudience: null, dataExternalBD: null })
      setDataServicio({ total: null, newAudience: null, dataExternalBD: null })
      setDataAplicacion({ total: null, newAudience: null, dataExternalBD: null })
      setDataGama({ total: null, newAudience: null, dataExternalBD: null })
      setDataVersionSO({ total: null, newAudience: null, dataExternalBD: null })
      setDataTecnologia({ total: null, newAudience: null, dataExternalBD: null })
      setDataTecNavegacion({ total: null, newAudience: null, dataExternalBD: null })
      setDataSistema({ total: null, newAudience: null, dataExternalBD: null })
      setDataComportamientos({ total: null, newAudience: null, dataExternalBD: null })
    } catch (err) {
        showMessage('error', 'Error al limpiar los filtros', 3);
    }
  }

  async function ClearFilters(){
    await createLog({
      action:"Borrado de filtros",
      id: uuidv4(),
      user:userContext.username,
      view:"Principal",
    });
    onFinishFilter();
  }

  useEffect(() => {
    if (filters.length != "") {
      setIsButtonDisabled(true);
    }else{
      setIsButtonDisabled(false)
    }
  }, [filters]);

  useEffect(() => {
    if(data){
      const indices = Object.keys(data)
      let dataTotales = []
      let columns = indices.map((item, index) => {
        if (data[item]) {
            data[item].forEach(indicador => {
            indicador.type = item === 'total' ? "Audiencia" : item === 'newAudience' ? 'Nueva audiencia' : "BD externa"
          })

          dataTotales.push(...data[item])

          return ({
            title: item === 'total' ? "Audiencia" : item === 'newAudience' ? 'Nueva audiencia' : "BD externa",
            dataIndex: `value${index}`,
            key: "value",
            align: "center",
            render(text, record) {
              return {
                props: {
                  className: "TextCharts",
                  style: { color: item === 'total' ? "#CC0000" : item === 'newAudience' ? "#FFA017" : "#00C6A2" },
                },
                children: <div>{text}</div>,
              };
            },
          })
        }
      })
      setTotalAudienceValue(dataTotales.filter(({ type }) => type == "Audiencia").map(({subscribers})=>subscribers))
      const nuevaAudiencia = dataTotales.find(({ type }) => type === "Nueva audiencia");
      const totalNewAudienceValue = nuevaAudiencia ? nuevaAudiencia.subscribers : 0;
      setTotalNewAudienceValue(totalNewAudienceValue);
      settotalBDexternaAudience(dataTotales.find(({ type }) => type == "BD externa")?.subscribers || null)
    }
  }, [data]);



  return (
    <div className="HeaderDetails header-container" >
      <PageHeader
        className="header-style"
        backIcon={false}
        title={dataAudience.name}
        extra={
          <>
            {dataAudience.name != "Nueva Audiencia" ? (
              <>
                <Button disabled={isQueryRunning} key="1" type="text" onClick={showModal2} style={{display: isButtonDisabled ? 'block' : 'none'}}>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1 19H19M11.7844 3.31171C11.7844 3.31171 11.7844 4.94634 13.419 6.58096C15.0537 8.21559 16.6883 8.21559 16.6883 8.21559M5.31963 15.9881L8.75234 15.4977C9.2475 15.4269 9.70636 15.1975 10.06 14.8438L18.3229 6.58096C19.2257 5.67818 19.2257 4.21449 18.3229 3.31171L16.6883 1.67708C15.7855 0.774305 14.3218 0.774305 13.419 1.67708L5.15616 9.93996C4.80248 10.2936 4.57305 10.7525 4.50231 11.2477L4.01193 14.6804C3.90295 15.4432 4.5568 16.097 5.31963 15.9881Z"
                      stroke="#0D33B9"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                    />
                  </svg>
                  Guardar cambios
                </Button>
                <Modal
                  clasName="ModalGA"
                  title="Atención"
                  open={isModalOpen2}
                  onCancel={() => setIsModalOpen2(false)}
                  footer={[
                    <Button key="back" onClick={handleCancel}>
                      Cancelar
                    </Button>,
                    <Button key="submit" type="primary" onClick={UpdateAudience}>
                      Aceptar
                    </Button>,
                  ]}
                >
                  <p>¿Estás seguro que deseas modificar la audiencia?</p>
                </Modal>
              </>
            ) : null}
            <Button 
              disabled={isQueryRunning} 
              style={{display: isButtonDisabled ? 'block' : 'none'}}
              key="2" type="text" onClick={showModal3}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <g clipPath="url(#clip0_2038_6141)">
              <path d="M24 0H0V24H24V0Z" fill="white" fillOpacity="0.01"/>
              <path d="M22.3909 12.0852L15.959 3.5498L7.06738 10.2501L13.75 18.5001L15.4278 17.3323L22.3909 12.0852Z" stroke="#0D33B9" strokeWidth="1.5" strokeLinejoin="round"/>
              <path d="M13.7504 18.4999L11.8311 20.0373L6.54939 20.0369L5.24914 18.3115L2.0332 14.0437L7.25039 10.1123" stroke="#0D33B9" strokeWidth="1.5" strokeLinejoin="round"/>
              <path d="M6.60254 20.0359L22.2824 20.0359" stroke="#0D33B9" strokeWidth="1.5" strokeLinecap="round"/>
              </g>
              <defs>
              <clipPath id="clip0_2038_6141">
              <rect width="24" height="24" fill="white"/>
              </clipPath>
              </defs>
              </svg>
              Limpiar filtros
            </Button>
            <Modal
              clasName="ModalGA"
              title="Atención"
              open={isModalOpen3}
              onCancel={() => setIsModalOpen3(false)}
              footer={[
                <Button key="back" onClick={handleCancel}>
                  Cancelar
                </Button>,
                <Button key="submit" type="primary" onClick={ClearFilters}>
                  Aceptar
                </Button>,
              ]}
            >
              <p>¿Estás seguro que deseas borrar los filtros?</p>
            </Modal>
            { filters.length != 0 ? 
            <Button disabled={isQueryRunning} key="3" type="text" onClick={showModal}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M21.75 12C21.75 11.5858 21.4142 11.25 21 11.25C20.5858 11.25 20.25 11.5858 20.25 12H21.75ZM12 3.75C12.4142 3.75 12.75 3.41421 12.75 3C12.75 2.58579 12.4142 2.25 12 2.25V3.75ZM9.43921 15.5906L9.33314 14.8481H9.33314L9.43921 15.5906ZM8.40939 14.5608L7.66693 14.4547L8.40939 14.5608ZM9.31048 10.8277L8.78015 10.2974L9.31048 10.8277ZM8.79557 11.8575L9.53803 11.9636H9.53803L8.79557 11.8575ZM13.1723 14.6895L13.7026 15.2199L13.1723 14.6895ZM12.1425 15.2044L12.2485 15.9469L12.1425 15.2044ZM20.4668 4.82047L19.9365 5.3508V5.3508L20.4668 4.82047ZM20.4668 7.39501L19.9365 6.86468L20.4668 7.39501ZM19.1795 3.5332L19.7099 3.00287V3.00287L19.1795 3.5332ZM16.605 3.5332L17.1353 4.06353V4.06353L16.605 3.5332ZM16.0677 4.82047C16.0677 4.40626 15.7319 4.07047 15.3177 4.07047C14.9035 4.07047 14.5677 4.40626 14.5677 4.82047L16.0677 4.82047ZM19.1795 9.43228C19.5937 9.43228 19.9295 9.09649 19.9295 8.68228C19.9295 8.26806 19.5937 7.93228 19.1795 7.93228V9.43228ZM20.25 12V17.4H21.75V12H20.25ZM17.4 20.25H6.6V21.75H17.4V20.25ZM3.75 17.4V6.6H2.25V17.4H3.75ZM6.6 3.75H12V2.25H6.6V3.75ZM3.75 6.6C3.75 5.02599 5.02599 3.75 6.6 3.75V2.25C4.19756 2.25 2.25 4.19756 2.25 6.6H3.75ZM6.6 20.25C5.02599 20.25 3.75 18.974 3.75 17.4H2.25C2.25 19.8024 4.19756 21.75 6.6 21.75V20.25ZM20.25 17.4C20.25 18.974 18.974 20.25 17.4 20.25V21.75C19.8024 21.75 21.75 19.8024 21.75 17.4H20.25ZM18.6492 4.06353L19.9365 5.3508L20.9971 4.29014L19.7099 3.00287L18.6492 4.06353ZM19.9365 6.86468L12.642 14.1592L13.7026 15.2199L20.9971 7.92534L19.9365 6.86468ZM9.84081 11.358L17.1353 4.06353L16.0747 3.00287L8.78015 10.2974L9.84081 11.358ZM12.0364 14.462L9.33314 14.8481L9.54527 16.3331L12.2485 15.9469L12.0364 14.462ZM9.15185 14.6669L9.53803 11.9636L8.05311 11.7515L7.66693 14.4547L9.15185 14.6669ZM9.33314 14.8481C9.22739 14.8633 9.13675 14.7726 9.15185 14.6669L7.66693 14.4547C7.5104 15.5504 8.44957 16.4896 9.54527 16.3331L9.33314 14.8481ZM8.78015 10.2974C8.38687 10.6907 8.13176 11.2009 8.05311 11.7515L9.53803 11.9636C9.57079 11.7343 9.67703 11.5218 9.84081 11.358L8.78015 10.2974ZM12.642 14.1592C12.4782 14.323 12.2657 14.4292 12.0364 14.462L12.2485 15.9469C12.7991 15.8682 13.3093 15.6131 13.7026 15.2199L12.642 14.1592ZM19.9365 5.3508C20.3545 5.76885 20.3545 6.44663 19.9365 6.86468L20.9971 7.92534C22.001 6.9215 22.001 5.29397 20.9971 4.29014L19.9365 5.3508ZM19.7099 3.00287C18.706 1.99904 17.0785 1.99904 16.0747 3.00287L17.1353 4.06353C17.5534 3.64549 18.2312 3.64549 18.6492 4.06353L19.7099 3.00287ZM15.3177 4.82047C14.5677 4.82047 14.5677 4.82085 14.5677 4.82122C14.5677 4.82135 14.5677 4.82174 14.5677 4.822C14.5677 4.82253 14.5677 4.82308 14.5677 4.82365C14.5677 4.82479 14.5677 4.82601 14.5678 4.82732C14.5678 4.82992 14.5678 4.83286 14.5679 4.83611C14.568 4.84261 14.5681 4.8504 14.5684 4.85943C14.569 4.87748 14.5701 4.90051 14.5719 4.92819C14.5756 4.98353 14.5825 5.05762 14.5954 5.14779C14.6211 5.32799 14.6709 5.57349 14.7671 5.86219C14.9605 6.44219 15.3394 7.19008 16.0747 7.92534L17.1353 6.86468C16.5833 6.31267 16.3186 5.77329 16.1901 5.38785C16.1255 5.19382 16.0948 5.03704 16.0803 4.93566C16.0731 4.88503 16.0699 4.8485 16.0686 4.82841C16.0679 4.81838 16.0677 4.8125 16.0676 4.81106C16.0676 4.81035 16.0676 4.81075 16.0677 4.8123C16.0677 4.81308 16.0677 4.81415 16.0677 4.81551C16.0677 4.81619 16.0677 4.81694 16.0677 4.81777C16.0677 4.81818 16.0677 4.81861 16.0677 4.81907C16.0677 4.81929 16.0677 4.81964 16.0677 4.81976C16.0677 4.82011 16.0677 4.82047 15.3177 4.82047ZM16.0747 7.92534C16.8099 8.66059 17.5578 9.03955 18.1378 9.23288C18.4265 9.32911 18.672 9.37888 18.8522 9.40462C18.9424 9.41751 19.0165 9.42441 19.0718 9.4281C19.0995 9.42995 19.1225 9.43099 19.1406 9.43157C19.1496 9.43186 19.1574 9.43204 19.1639 9.43214C19.1671 9.43219 19.1701 9.43223 19.1727 9.43225C19.174 9.43226 19.1752 9.43227 19.1763 9.43227C19.1769 9.43227 19.1775 9.43227 19.178 9.43227C19.1783 9.43227 19.1786 9.43228 19.1788 9.43228C19.1792 9.43228 19.1795 9.43228 19.1795 8.68228C19.1795 7.93228 19.1799 7.93228 19.1802 7.93228C19.1804 7.93228 19.1807 7.93228 19.1809 7.93228C19.1814 7.93228 19.1818 7.93228 19.1822 7.93228C19.1831 7.93228 19.1838 7.93229 19.1845 7.93229C19.1859 7.9323 19.1869 7.93232 19.1877 7.93233C19.1893 7.93236 19.1897 7.93237 19.1889 7.93235C19.1875 7.93231 19.1816 7.93209 19.1716 7.93142C19.1515 7.93008 19.115 7.92693 19.0643 7.9197C18.963 7.90522 18.8062 7.87453 18.6122 7.80985C18.2267 7.68137 17.6873 7.41669 17.1353 6.86468L16.0747 7.92534Z" fill="#0D33B9" />
              </svg>
              Generar nueva audiencia
            </Button>
              : null
            }
            <Modal
              clasName="ModalGA"
              title="Registrando Nueva Audiencia"
              open={isModalOpen}
              onCancel={() => setIsModalOpen(false)}
              footer={[
                <Button key="back" onClick={handleCancel}>
                  Cancelar
                </Button>,
                <Button key="submit" type="primary" onClick={CreateAudience}>
                  Guardar
                </Button>,
              ]}
            >
              <Form
                form={form}
                name="form-name"
                layout="vertical"
                initialValues={{ remember: false }}
                onFinish={CreateAudience}
              >
                <Form.Item
                  className="SubmenuRegularGA"
                  name="name"
                  rules={[
                    {
                      required: true,
                      message: "Es requerido nombrar a la audiencia",
                    },
                  ]}
                >
                  <Input
                    allowClear
                    size="large"
                    placeholder="Ingresa el nombre de la Nueva Audiencia"
                    title="Name"
                    onFinish={CreateAudience}

                  />
                </Form.Item>
              </Form>
            </Modal>
          </>
        }
      />
      <Row
        className="header-row"
      >
        <Col span={18}>
          <Row className="header-row-mar">
            <Col span={4} align="middle">
            <>
              <Title className="CifraGeneralResaltadaGA" level={3}>
                {topComportamientos.value}
              </Title>
              <Text className="SubmenuRegularGA">{topComportamientos.name}</Text>
            </>
            </Col>
            <Col span={4} align="middle">
            <>
              <Title className="CifraGeneralResaltadaGA" level={3}>
                {topUbicaciones.value}
              </Title>
              <Text className="SubmenuRegularGA">{topUbicaciones.name}</Text>
            </>
            </Col>
            <Col span={4} align="middle">
            <>
              <Title className="CifraGeneralResaltadaGA" level={3}>
                {topGeneros.value}
              </Title>
              <Text className="SubmenuRegularGA">{topGeneros.name}</Text>
            </>
            </Col>
            <Col span={4} align="middle">
            <>
              <Title className="CifraGeneralResaltadaGA" level={3}>
                {topPlanCost.value}
              </Title>
              <Text className="SubmenuRegularGA">{topPlanCost.name}</Text>
            </>
            </Col>
            <Col span={4} align="middle">
            <>
              <Title className="CifraGeneralResaltadaGA" level={3}>
                {topEdad.value}
              </Title>
              <Text className="SubmenuRegularGA">{topEdad.name}</Text>
            </>
            </Col>
            <Col span={4} align="middle">
            <>
              <Title className="CifraGeneralResaltadaGA" level={3}>
                {topDispositivos.value}
              </Title>
              <Text className="SubmenuRegularGA">{topDispositivos.name}</Text>
            </>
            </Col>
            {/*
            <Col span={4} align="middle">
              <TopValue
                type={"tipo_dispositivo"}
                request={"getTypeDevices"}
              />
            </Col>
            <Col span={3} align="middle">
              <TopValue type={"os_dispositivo"} request={"getOsDevices"} />
          </Col>*/}
          </Row>
        </Col>
        <Col
          span={3}
          align="middle"
          className="header-col"
        >
          <Title className="CifraGeneralResaltadaGA" level={3}>
          {totalAudienceValue ? totalAudienceValue.toLocaleString( "en-US", { notation: "compact", compactDisplay: "short" }): null }
          </Title>
          <Text className="SubmenuRegularGA">Audiencia</Text>
        </Col>
        <Col span={3} align="middle">
          {filters.length !==0 && totalAudienceValue ? (
            <Row align="middle" justify="space-between">
              <Col>
                {totalBDexternaAudience?
                <TotalFilter valor={totalBDexternaAudience} filter={totalBE} color={"#00C6A2"} text={"Nueva Audiencia BE"} loadingTotal={loadingTotal}/>
                :
                <TotalFilter valor={totalNewAudienceValue} filter={totalNewAudience} color={"#FF596F"} text={"Nueva Audiencia"} loadingTotal={loadingTotal}/>
                }
              </Col>
            </Row>
          ) : null}
        </Col>
      </Row>
      { totalBE ? (
      <Row
        className="header-row"
      >
        <Col span={18}>
          <Row className="header-row-mar">
            <Col span={4} align="middle">
              <TopValueBE request={"getBehavior"} dataBaseExternal={dataBaseExternal}/>
            </Col>
            <Col span={4} align="middle">
              <TopValueBE request={"getLocation"} dataBaseExternal={dataBaseExternal} />
            </Col>
            <Col span={4} align="middle">
              <TopValueBE request={"getGender"} dataBaseExternal={dataBaseExternal} />
            </Col>
            <Col span={4} align="middle">
              <Title className="CifraGeneralResaltadaGA topCifraBE" level={3} color={"#00C6A2"}>
                {topDispositivos.value}
              </Title>
              <Text className="SubmenuRegularGA">{topDispositivos.name}</Text>
            </Col>
            <Col span={4} align="middle">
              <TopValueBE request={"getAges"} dataBaseExternal={dataBaseExternal} />
            </Col>
            <Col span={4} align="middle">
              <TopValueBE
                type={"marca_dispositivo"}
                request={"getBranchDevices"}
                dataBaseExternal={dataBaseExternal}
              />
            </Col>
          </Row>
        </Col>
        <Col
          span={3}
          align="middle"
          className="header-col"
        >
          <TotalAudienceBE dataBaseExternal={dataBaseExternal}/>
        </Col>
        <Col span={3} align="middle">
            <Row align="middle" justify="space-between">
              <Col>
                <TotalFilter valor={totalNewAudienceValue} filter={totalBE} color={"#00C6A2"} text={"Nueva Audiencia BE"} loadingTotal={loadingTotal}/>
              </Col>
            </Row>
        </Col>
      </Row>
      ) : null}
    </div>
  );
};


export default HeaderDetails;